<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <keep-alive include="RemoveWatermark,AiImageRemove,VideoRemove,RemoveBg">
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>


<script>

export default {
  name: 'App',
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
